import {
  CButton,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react';
import { useEffect, useRef, useState } from 'react';
import adminApi from 'services/adminApi';
import './importData.scss';
import { PreviewModal } from './PreviewModal';
const ImportDataPage = () => {
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState(data);
  const [visible, setVisible] = useState(false);
  const [previewData, setPreviewData] = useState([]);

  const fileInputRef = useRef(null);
  const refIdUpload = useRef(null);
  const refBulkUpdate = useRef(false);

  const getListData = async () => {
    const res = await adminApi({ url: '/dashboard' });
    const result = await res.json();
    setData(result.data);
    setDataFilter(result.data);
  };

  const handleUpload = async () => {
    const file = fileInputRef.current.files[0];
    const id = refIdUpload.current;
    const isBulkUpdate = refBulkUpdate.current;
    if (!file || (!id && !isBulkUpdate)) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', data.find((item) => item._id === id)?.name);
    const res = await adminApi({
      url: `/dashboard/${isBulkUpdate ? 'bulk-update' : id}`,
      method: 'PUT',
      toFormData: true,
      body: formData,
    });
    const { isSuccess, data: finalData, message } = await res.json();
    const result = finalData.reduce(
      (acc, item) => {
        if (!item) acc.failed++;
        else acc.success++;
        return acc;
      },
      { success: 0, failed: 0 }
    );
    if (!isSuccess) {
      alert(message);
      return;
    }
    if (isBulkUpdate) {
      setData((prev) => {
        return prev.map((item) => {
          const newItem = finalData.find((db) => item?._id === db?._id);
          return newItem ? { ...item, data: newItem.data } : item;
        });
      });
    } else {
      setData((prev) =>
        prev.map((item) =>
          item._id === id ? { ...item, data: finalData.data } : item
        )
      );
    }
    refBulkUpdate.current = false;
    fileInputRef.current.value = null;
    alert(`Upload success, ${result.success} success, ${result.failed} failed`);
  };

  useEffect(() => {
    getListData();
  }, []);

  const filterData = (value) => {
    setDataFilter(
      data.filter((child) =>
        child.name.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  return (
    <div className="admin-table">
      <CRow className="my-2">
        <CCol
          className="text-end header_action"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            onChange={(e) => filterData(e.target.value)}
          />
          <div className="d-flex gap-2">
            <CButton
              className="create-btn"
              style={{ fontSize: '12px' }}
              color="info"
              onClick={() => {
                window.open(`/assets/example.xlsx`, '_blank');
              }}
            >
              Download Sample Imput File
            </CButton>
            <CButton
              className="create-btn"
              style={{ fontSize: '12px' }}
              color="success"
              onClick={() => {
                refBulkUpdate.current = true;
                fileInputRef.current.click();
              }}
            >
              Import Data
            </CButton>
          </div>
        </CCol>
      </CRow>

      <div
        style={{
          padding: '15px 25px',
          backgroundColor: 'white',
          borderRadius: '5px',
          overflowX: 'auto',
        }}
      >
        <CTable className="bg-dark" style={{ fontSize: '13px' }}>
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell className="align-middle">#</CTableHeaderCell>
              <CTableHeaderCell className="align-middle">
                Hardware Name
              </CTableHeaderCell>
              <CTableHeaderCell className="align-middle">
                Hardware ID
              </CTableHeaderCell>
              <CTableHeaderCell className="align-middle">
                Last updated date
              </CTableHeaderCell>
              <CTableHeaderCell className="s" style={{ width: '350px' }}>
                Action
              </CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {dataFilter.map(
              ({ _id: id, name, hotspot_id, updatedAt }, index) => (
                <CTableRow key={id}>
                  <CTableHeaderCell scope="row" className="align-middle">
                    {index + 1}
                  </CTableHeaderCell>
                  <CTableDataCell
                    className="align-middle"
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    {name}
                  </CTableDataCell>
                  <CTableDataCell
                    className="align-middle"
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    {hotspot_id}
                  </CTableDataCell>
                  <CTableDataCell
                    className="align-middle"
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    {new Date(updatedAt).toLocaleString()}
                  </CTableDataCell>
                  <CTableDataCell className="align-middle d-flex">
                    {/* <CButton
                    className="edit-btn me-2"
                    color="info"
                    style={{ fontSize: '12px' }}
                    onClick={() => handleClickUpload(id)}
                  >
                    Upload
                  </CButton> */}
                    <CButton
                      className="delete-btn"
                      color="primary"
                      style={{ fontSize: '12px' }}
                      onClick={() => {
                        setPreviewData({
                          updatedAt: updatedAt,
                          data: JSON.parse(data[index].data),
                        });
                        setVisible(true);
                      }}
                    >
                      Preview
                    </CButton>
                  </CTableDataCell>
                </CTableRow>
              )
            )}
          </CTableBody>
        </CTable>
      </div>
      <PreviewModal
        visible={visible}
        setVisible={setVisible}
        previewData={previewData}
      />
      <input
        ref={fileInputRef}
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        type="file"
        onChange={handleUpload}
        hidden
      />
    </div>
  );
};

export default ImportDataPage;
